import React from 'react';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { getSrc } from '~app/helpers/assetLoading';
import useStyles from '../useStyles';
import { TemplateCardProps } from '~helpers/types';
import SplitHeroButton from '~app/components/SplitHero/SplitHeroButton';

const TemplateCard = ({ template, templateCTA, ...metricsProps }: TemplateCardProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <Box className={classes.templateCard}>
      <img src={getSrc(template.image)} alt={template.title} className={classes.pathImage} />
      <Box className={classes.cardContent}>
        <section>
          <Typography variant="cardTitle" weight="medium" align="left" component="h4">
            {template.title}
          </Typography>
          <Typography weight="regular" align="left" component="p">
            {template.description}
          </Typography>
        </section>
        <SplitHeroButton
          isTemplatePage
          size="md"
          href={template.ctaLink}
          variant="ghost"
          text={templateCTA}
          metricsData={{
            ut_ctatext: templateCTA,
            itemSelected: template.title,
          }}
          templateType={metricsProps.templateType as string}
          {...metricsProps}
        />
      </Box>
    </Box>
  );
};

export default TemplateCard;
